import { http } from '@/utils/http'

export interface IFooItem {
  id: string
  name: string
}

/** GET 请求 */
export function getFooAPI(name: string) {
  return http.get('/nxcloud-app-user/sysMessage/send/smsCode', { name })
}

/** POST 请求 */
export function postFooAPI(data: object) {
  return http.post('/nxcloud-app-user/sysMessage/send/smsCode', data)
}
/** POST 请求；需要传递 query 参数的范例；微信小程序经常有同时需要query参数和body参数的场景 */
export function postFooAPI2(name: string) {
  return http.post<IFooItem>('/foo', { name })
}

// 地图红包
export function getRedPacket(data: object) {
  return http.post('/nxcloud-app-redPacket/c/mini-c/v1/redPackageInstance/page', data)
}

// 红包
export function receivePackage(data: object) {
  return http.post(
    '/nxcloud-app-redPacket/c/mini-c/v1/redPackageInstanceRecord/receivePackage',
    data,
  )
}

/** 领地公约 */
export function getSpaceAgreementApi() {
  return http.get(
    '/nxcloud-app-user/c/app-c/v1/systemConfigApi/getConfigByKey/COMMUNITY_ALLIED_SPACE_AGREEMENT',
  )
}

/** 商场配置数据 */
export function getGoodsLandHomeApi() {
  return http.get(
    '/nxcloud-app-user/c/app-c/v1/systemConfigApi/getConfigByKey/GOODS_LAND_HOME',
  )
}

// 校验开包接口
export function checkRedPackage(data: object) {
  return http.post('/nxcloud-app-redPacket/c/mini-c/v1/redPackageInstance/getDetail', data)
}

// 查询社区内容
export function listFeedContentByLocation(data: object) {
  return http.post('/nxcloud-app-feed/c/mini-c/v1/feedContent/listFeedContentByLocation', data)
}

// 查询发布内容
export function findPublish(data: object) {
  return http.post('/nxcloud-app-feed/c/mini-c/v1/feedContent/find', data)
}

// 用户信息
export function getUserInfo(data: object) {
  return http.post('/nxcloud-app-user/c/mini-c/v1/auth/getCurrentUserInfo', data)
}

// 添加关注
export function addFollow(data: object) {
  return http.post('/nxcloud-app-user/c/mini-c/v1/bizUserFollow/addFollow', data)
}
// 取消关注
export function cancelFollow(data: object) {
  return http.post('/nxcloud-app-user/c/mini-c/v1/bizUserFollow/cancelFollow', data)
}

// 个人信息
export function baseUserInfo(data: object) {
  return http.post('/nxcloud-app-user/c/mini-c/v1/user/getBaseUserInfo', data)
}

// 店铺列表
export function getShopListByMallDecoration(data: object) {
  return http.post('/nxcloud-app-trade/c/app-c/v1/shopManage/getAllShopList', data)
}

export function getShopTab(data: object) {
  return http.post('/nxcloud-app-trade/c/app-c/v1/bizTabManage/queryPage', data)
}

export function getAdressTree() {
  return http.post('/nxcloud-app-user/c/app-c/v1/addrApi/tree')
}

// 购买后详情
export function buyNftDetail(data: object) {
  return http.post('/nxcloud-app-assets/c/mini-c/v1/assets/instance/detail', data)
}

export function switchInfoApi(name) {
  return http.get(`/nxcloud-app-user/c/app-c/v1/systemConfigApi/getConfigByKey/${name}`)
}

export function getConfigByClientVersionApi(header) {
  return http.post(`/nxcloud-app-user/c/app-c/v1/systemConfigApi/getConfigByClientVersion`, {}, {}, header)
}

// 头像框
export function getCurrentUserInfoAvatar(data) {
  return http.post('/nxcloud-app-user/c/app-c/v1/auth/getCurrentUserInfo', data)
}
// 领地首页接口
export function getLandList(data: object) {
  return http.post(`/nxcloud-app-society/c/mini-c/v1/society/square/message/scrollList`, data)
}
// 领地广场详情
export function getLandSquareDetail(data: object) {
  return http.post('/nxcloud-app-society/c/mini-c/v1/society/aggregation/detail', data)
}

/** 领地 -- 加入、领取、购买 弹窗 */
export function joinModalApi(data: object) {
  return http.post('/nxcloud-app-society/c/mini-c/v1/society/member/modal', data)
}
// 加入领地
export function joinSociety(data: object) {
  return http.post('/nxcloud-app-society/c/mini-c/v1/society/member/add', data)
}
/** 领取权益 */
export function attainApi(data: object) {
  return http.post('/nxcloud-app-assets/c/mini-c/v1/assets/goods/attain', data)
}

/** 领地获取用户列表 */
export function groupDataApi(data: object) {
  return http.post('/nxcloud-app-society/c/mini-c/v1/society/member/groupData', data)
}
/** 渠道商品分页列表 */
export function nftInfoApi(data: object) {
  return http.post('/nxcloud-app-society/c/mini-c/v1/society/nftInfo', data)
}
// 领地广场频道列表
export function getLandSquareChannelList(data: object) {
  return http.post('/nxcloud-app-society/c/mini-c/v1/society/channel/list', data)
}
// 已加入的领地广场列表
export function getLandSquareList(data: object) {
  return http.post('/nxcloud-app-society/c/mini-c/v1/society/square/join/pageList', data)
}
// 创建指纹编码
export function createFingerprintCodeApi(data: object) {
  return http.post(`/nxcloud-app-dsp/c/app-c/v1/CPromotionFingerprintInfo/save`, data)
}
export function getFingerprintCodeApi(data: object) {
  return http.post(`/nxcloud-app-dsp/c/app-c/v1/CPromotionFingerprintInfo/getDetail`, data)
}
// 推广事件上报
export const savePromotionEvent = (data: object) => {
  return http.post('/nxcloud-app-dsp/c/app-c/v1/CPromotionEventInfo/saveEvent', data)
}
// 生成微信小程序URL
export const generateUrlLink = (data: { path: string; query: string }) => {
  return http.post(`/nxcloud-base-wechat/wx/ma/code/LAND-C/10000/generateUrlLink`, {}, data)
}

// 发送短信验证码
export const sendSms = (data: object) => {
  return http.post('/nxcloud-app-user/c/app-c/v1/messageManagement/sendSms', data)
}
// 选择地址
export const businessTreeAPI = (data: any) => {
  return http.post(`/nxcloud-app-user/c/app-c/v1/addrApi/businessTreeDown`, data)
}

// 绑定邀请码
export const writeInviteCode = (data: object) => {
  return http.post('/nxcloud-app-user/c/mini-c/v1/bizUserInvite/writeInviteCode', data)
}

// /c/app-c/v1/assets/order/page

export const getFreeOrderPage = (data: object) => {
  return http.post('/nxcloud-app-assets/c/app-c/v1/assets/order/page', data)
}

// 查询订单详情
export const getOrderDetail = (data: object) => {  
    return http.post('/nxcloud-app-assets/c/app-c/v1/assets/order/detail', data)
}

// 查询资产详情
export const getInstanceDetail = (data: object) => {  
    return http.post('/nxcloud-app-assets/c/app-c/v1/assets/instance/detail', data)
}

// 活动广场
export const activitySquare = (data: object) => {
  return http.post('/nxcloud-app-feed/c/mini-c/v1/activity/content/square', data)
}

// 动态点赞
export const dynamicPraise = (data) => {
  return http.post('/nxcloud-app-feed/c/mini-c/v1/feedContent/like', data)
}

export const goodsSpu = (data: object) => {
  return http.post('/nxcloud-app-trade/c/app-c/v1/CProduct/selectList', data)
}

export const digitWallet = (data: object) => {
  return http.post('/nxcloud-app-bfi/c/app-c/v1/account/digitWallet', data)
}

export const getMyWalletData = (data: object) => {
  return http.post('/nxcloud-app-bfi/c/app-c/v1/account/wallet', data)
}

export const cashInfo = (data: object) => {
  return http.post('/nxcloud-app-bfi/c/app-c/v1/account/cash/info', data)
}



 

